export const analyticsEvents = {
  OPEN: 'main_page_loaded',
  REQUEST_CLICK: 'main_page_request_click',
  SEARCH_FORM: {
    SUBMIT: 'main_page_search_submit',
  },
  CASHBACK_BANNER_CLICK: 'main_page_cashback_banner_clicked',
};
